import { Component, OnInit, ChangeDetectorRef, AfterViewInit } from "@angular/core";
import {
  Chart,
  ChartConfiguration,
  ChartTypeRegistry,
  CategoryScale,
  LinearScale,
  BarElement,
  BarController,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  LineController,
  PieController,
  ArcElement
} from "chart.js";
import { AuthService } from "../core/auth/auth.service";
import { AppConfig } from 'src/config/app.config';
import { ChartType } from '../core/chart.model';
import { UserType } from "../core/userType.model";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
  standalone: false
})
export class DashboardComponent implements OnInit, AfterViewInit {
  btdchart: Chart;
  mtdchart: Chart;
  ytdchart: Chart;
  btdChartType: ChartType = ChartType.bar;
  mtdChartType: ChartType = ChartType.bar;
  ytdChartType: ChartType = ChartType.bar;
  _apiUrl: string;
  ChartCal: any;
  cdr: any;
  _editWorkshop: boolean;
  userbaseTypeId: number;


  constructor(
    private authService: AuthService,
    private appConfig: AppConfig,
    private _cdr: ChangeDetectorRef) {
    this._apiUrl = appConfig.baseUrl;
    this.cdr = _cdr;
    this.userbaseTypeId = parseInt(atob(localStorage.getItem("USER_BASE_TYPE_ID")));
  }
  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  ngOnInit() {
    Chart.register(
      CategoryScale,
      LinearScale,
      BarElement,
      BarController,
      Title,
      Tooltip,
      Legend,
      PointElement,
      LineElement,
      LineController,
      PieController,
      ArcElement
    );
    this.getDashBoard();
    this.getChartCalculations();
    if (this.userbaseTypeId == UserType.Dealer || this.userbaseTypeId == UserType.WorkShop) {
      this.ValidateWorkshopRequiredData();
    }
  }

  getDashBoard() {
    this.authService
      .get(
        this._apiUrl + "/api/v1/Dashboard/chart")
      .subscribe(
        (response) => {
          if (response) {
            this.BindBTDChart(response.labelBTD, response.dataBTD, "canvas");
            this.BindMTDChart(response.labelMTD, response.dataMTD, "canvas1");
            this.BindYTDChart(response.labelYTD, response.dataYTD, "canvas2");
          }
        },
        (error) => {
        }
      );
  }

  getChartCalculations() {
    this.authService
      .get(
        this._apiUrl + "/api/v1/Dashboard/calculations")
      .subscribe(
        (response) => {
          if (response) {
            this.ChartCal = response;
          }
        },
        (error) => {
        }
      );
  }

  changeChartType(type: string) {
    if (type == "BTD") {
      (this.btdchart.config as ChartConfiguration).type = ChartType[(this.btdChartType as unknown) as keyof ChartTypeRegistry];
      this.btdchart.update();
    }
    if (type == "MTD") {
      (this.mtdchart.config as ChartConfiguration).type = ChartType[(this.mtdChartType as unknown) as keyof ChartTypeRegistry];
      this.mtdchart.update();
    }
    if (type == "YTD") {
      (this.ytdchart.config as ChartConfiguration).type = ChartType[(this.ytdChartType as unknown) as keyof ChartTypeRegistry];
      this.ytdchart.update();
    }
  }

  BindBTDChart(label: any, data: any, canvasId: string) {
    const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');

    this.btdchart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: label,
        datasets: [
          {
            data: data,
            borderColor: '#3cba9f',
            backgroundColor: this.poolColors(data.length),
          },
        ],
      },
      options: {
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          x: {
            display: true,
            ticks: {
              color: '#C7C7CC',
              font: { size: 11 },
            },
          },
          y: {
            display: true,
          },
        },
      },
    });
  }

  BindMTDChart(label: any, data: any, canvasId: string) {
    const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');

    this.mtdchart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: label,
        datasets: [
          {
            data: data,
            borderColor: '#3cba9f',
            backgroundColor: this.poolColors(data.length),
          },
        ],
      },
      options: {
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          x: {
            display: true,
            ticks: {
              color: '#C7C7CC',
              font: {
                size: 11,
              },
            },
          },
          y: {
            display: true,
          },
        },
      },
    });
  }

  BindYTDChart(label: any, data: any, canvasId: string) {
    const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
    const ctx = canvas.getContext('2d');

    this.ytdchart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: label,
        datasets: [
          {
            data: data,
            borderColor: '#3cba9f',
            backgroundColor: this.poolColors(data.length),
          },
        ],
      },
      options: {
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          x: {
            display: true,
            ticks: {
              color: '#C7C7CC',
              font: {
                size: 11,
              },
            },
          },
          y: {
            display: true,
          },
        },
      },
    });
  }

  poolColors(length) {
    var pool = [];
    for (var i = 0; i < length; i++) {
      pool.push(this.dynamicColors());
    }
    return pool;
  }

  dynamicColors() {
    var r = Math.floor(Math.random() * 255);
    var g = Math.floor(Math.random() * 255);
    var b = Math.floor(Math.random() * 255);
    return "rgba(" + r + "," + g + "," + b + ", 0.5)";
  }

  //Workshop Edit
  public get isShowWorkshopEdit(): boolean {
    return this._editWorkshop;
  }

  ValidateWorkshopRequiredData() {
    this.authService
      .get(
        this._apiUrl + "/api/v1/Workshops/ValidateWorkshopRequiredData")
      .subscribe(
        (response) => {
          this._editWorkshop = !response;
        },
        (error) => {
        }
      );
  }

  onCloseModal(arg: boolean) {
    this._editWorkshop = arg;
  }

}

